import { Typography } from "@mui/material";

import SidebarSection from "../../SidebarSection";

const TechTypeSection = ({ techTypes }: { techTypes: string }) => {
  const techTypesList = techTypes.split(",");

  return (
    <SidebarSection title="Product Types:">
      {techTypesList.map((tech) => (
        <Typography variant="body1" key={tech}>
          {tech}
        </Typography>
      ))}
    </SidebarSection>
  );
};
export default TechTypeSection;
